import {
  DatahubEntity,
  IDefaultSchema,
  IPlaybackSpeedSchema,
  PlaybackSpeedAction,
  DATA_VERSION,
  CaptureEventData,
  CaptureEvent,
  IDefaultEventParams,
} from 'src/interfaces/Datahub';
import playbackSpeedSchema from './schema';

class PlaybackSpeed {
  private defaultData: IDefaultSchema;

  constructor(defaultData: IDefaultSchema) {
    this.defaultData = defaultData;
  }

  get schema() {
    return playbackSpeedSchema;
  }

  change(captureEvent: CaptureEvent<PlaybackSpeedAction>, params: { playbackRate: number } & IDefaultEventParams) {
    const event: IPlaybackSpeedSchema = {
      ...this.defaultData,
      speed: params.playbackRate,
      time: Math.floor(params.currentTime),
    };

    const data: CaptureEventData = {
      event,
      data_version: DATA_VERSION['1.0'],
    };

    captureEvent(DatahubEntity.PLAYBACK_SPEED, PlaybackSpeedAction.CHANGE, data);
  }
}
export default PlaybackSpeed;
